import { Component, OnInit, ElementRef, ViewChild, HostListener } from '@angular/core';
import { JWTTokenServiceService } from 'src/app/public/services/token.service';
import { HomeService } from '../../services/home.service';
import { AnalyticsService } from '../../services/analytics.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { PermissionService } from '../../services/permission.service';




@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent {
  @ViewChild('scrollContainer') scrollContainer!: ElementRef;
  isMobileView = window.innerWidth <= 1024;
  active = 1;
  data: any;
  leadLoading: boolean = false;
  appointmentLoading: boolean = false;
  leadsAnalytics: any;
  appointmentAnalytics: any;
  opthoAnalytics: any;
  opthoAnalyticsLoading: boolean = false;
  currentTab = "leads";
  totalLeads: any = 0;
  chatBotAnalytics: any;

  // Date filter state
  leadActiveFilter: string = 'this_year';
  appointmentActiveFilter: string = 'this_year';

  // Custom date range
  showLeadCustomRange: boolean = false;
  showAppointmentCustomRange: boolean = false;
  leadCustomStart: string = '';
  leadCustomEnd: string = '';
  appointmentCustomStart: string = '';
  appointmentCustomEnd: string = '';
  todayStr: string = new Date().toISOString().split('T')[0];

  dateFilters = [
    { key: 'this_week',   label: 'This Week' },
    { key: 'last_week',   label: 'Last Week' },
    { key: 'this_month',  label: 'This Month' },
    { key: 'last_month',  label: 'Last Month' },
    { key: 'this_year',   label: 'This Year' },
    { key: 'last_year',   label: 'Last Year' },
    { key: 'custom',      label: 'Custom Range' },
  ];

  constructor(private jwt: JWTTokenServiceService, private api: AnalyticsService, private localStorage: LocalStorageService, private checkPermission: PermissionService) {}

  /** Compute start_date / end_date for a given filter key */
  private getDateRange(filterKey: string, customStart?: string, customEnd?: string): { start_date: string; end_date: string } {
    const now = new Date();
    const fmt = (d: Date) => d.toISOString().split('T')[0];

    switch (filterKey) {
      case 'this_week': {
        const day = now.getDay();
        const mon = new Date(now); mon.setDate(now.getDate() - ((day + 6) % 7));
        const sun = new Date(mon); sun.setDate(mon.getDate() + 6);
        return { start_date: fmt(mon), end_date: fmt(sun) };
      }
      case 'last_week': {
        const day = now.getDay();
        const thisMon = new Date(now); thisMon.setDate(now.getDate() - ((day + 6) % 7));
        const lastMon = new Date(thisMon); lastMon.setDate(thisMon.getDate() - 7);
        const lastSun = new Date(thisMon); lastSun.setDate(thisMon.getDate() - 1);
        return { start_date: fmt(lastMon), end_date: fmt(lastSun) };
      }
      case 'this_month': {
        const start = new Date(now.getFullYear(), now.getMonth(), 1);
        const end   = new Date(now.getFullYear(), now.getMonth() + 1, 0);
        return { start_date: fmt(start), end_date: fmt(end) };
      }
      case 'last_month': {
        const start = new Date(now.getFullYear(), now.getMonth() - 1, 1);
        const end   = new Date(now.getFullYear(), now.getMonth(), 0);
        return { start_date: fmt(start), end_date: fmt(end) };
      }
      case 'this_year': {
        return { start_date: `${now.getFullYear()}-01-01`, end_date: `${now.getFullYear()}-12-31` };
      }
      case 'last_year': {
        const y = now.getFullYear() - 1;
        return { start_date: `${y}-01-01`, end_date: `${y}-12-31` };
      }
      case 'custom': {
        return { start_date: customStart || fmt(now), end_date: customEnd || fmt(now) };
      }
      default:
        return { start_date: `${now.getFullYear()}-01-01`, end_date: `${now.getFullYear()}-12-31` };
    }
  }

  _check(module: any, feature: any) {

    if (this.checkPermission.getAccess(module) && this.checkPermission.getfeatureAccess(module, feature)) {
      return true
    } else {
      return false
    }

  }
  ngOnInit(): void {
    this.fnGetLeadAnalytics();
  }

  fnChangeTab(event: any) {
    this.currentTab == event;
    console.log(event)
    if (event == 'appointment') {
      this.fnGetAppointmentAnalytics();
    }
    else if (event == 'lead') {
      this.fnGetLeadAnalytics();
    }
    else if (event == 'chatbot') {
      this.fnChatbotAnalyticsData();
    }
    else if (event == 'Optometrist') {
      console.log("hello")
      this.opthoAnalytics = {
        platform_wise_appointments: { "tina": { "Apr": 0, "Mar": 10, "Feb": 2, "Jan": 0, "Dec": 0, "Nov": 0, "Oct": 0, "Sep": 0, "Aug": 0, "Jul": 0, "Jun": 0, "May": 0 }, "manual": { "Apr": 0, "Mar": 0, "Feb": 14, "Jan": 1, "Dec": 0, "Nov": 0, "Oct": 0, "Sep": 0, "Aug": 0, "Jul": 0, "Jun": 0, "May": 0 }, "whatsapp": { "Apr": 0, "Mar": 0, "Feb": 0, "Jan": 0, "Dec": 0, "Nov": 0, "Oct": 0, "Sep": 0, "Aug": 0, "Jul": 0, "Jun": 0, "May": 0 } }
      }
      this.opthoAnalyticsLoading = true;
    }

    console.log("opto", this.opthoAnalytics)
    console.log("leads", this.opthoAnalyticsLoading)
  }

  fnChatbotAnalyticsData() {
    let param = {
      // client_id: this.localStorage.getClientId(),
      client_id: "6f20b077-dc46-467d-9e80-fd7027169e9d",
    }

    this.api.getChatbotAnalytics(param).subscribe({
      next: (res) => {
        console.log(res)
        if (res) {
          this.chatBotAnalytics = res;
          this.chatBotAnalytics.user_ratings = {
            "5": 80,
            "4": 45,
            "3": 15,
            "2": 10,
            "1": 3,
          }
          this.chatBotAnalytics.user_feedbacks = {
            "negative": 0,
            "positive": 52
          }
        } else {
          this.chatBotAnalytics = {
            "user_data": {
              "0": 0,
              "1": 0,
              "2": 0,
              "3": 0,
              "4": 0,
              "5": 0,
              "6": 0,
              "7": 0,
              "8": 0,
              "9": 0,
              "10": 0,
              "11": 0
            },
            "common_disease": "",
            "avg_waiting_time": 0,
            "hot_leads": 0,
            "total_users": 0,
            "total_messages": 0,
            "old_appointment": 0,
            "active_hours": 0,
            "top_active_hours": {
              "13:00-14:00": 0,
              "15:00-16:00": 0,
              "11:00-12:00": 0,
              "09:00-10:00": 0,
              "05:00-06:00": 0
            },
            "unique_users": "0",
            "total_leads_last_month": {
              "whatsapp": 0,
              "youtube": 0,
              "total": 0,
              "twitter": 0,
              "messenger": 0,
              "facebook": 0,
              "instagram": 0,
              "linkedin": 0,
              "tina": 0
            },
            "new_appointment": 0,
            "user_feedbacks": {
              "negative": 0,
              "positive": 0
            },
            "user_ratings": {
              "5": 0,
              "4": 0,
              "3": 0,
              "2": 0,
              "1": 0,
            },
            "total_ratings": 0,
            "cold_leads": 0,
            "leads": {
              "whatsapp": {
                "0": 0,
                "1": 0,
                "2": 0,
                "3": 0,
                "4": 0,
                "5": 0,
                "6": 0,
                "7": 0,
                "8": 0,
                "9": 0,
                "10": 0,
                "11": 0
              },
              "youtube": {
                "0": 0,
                "1": 0,
                "2": 0,
                "3": 0,
                "4": 0,
                "5": 0,
                "6": 0,
                "7": 0,
                "8": 0,
                "9": 0,
                "10": 0,
                "11": 0
              },
              "twitter": {
                "0": 0,
                "1": 0,
                "2": 0,
                "3": 0,
                "4": 0,
                "5": 0,
                "6": 0,
                "7": 0,
                "8": 0,
                "9": 0,
                "10": 0,
                "11": 0
              },
              "messenger": {
                "0": 0,
                "1": 0,
                "2": 0,
                "3": 0,
                "4": 0,
                "5": 0,
                "6": 0,
                "7": 0,
                "8": 0,
                "9": 0,
                "10": 0,
                "11": 0
              },
              "facebook": {
                "0": 0,
                "1": 0,
                "2": 0,
                "3": 0,
                "4": 0,
                "5": 0,
                "6": 0,
                "7": 0,
                "8": 0,
                "9": 0,
                "10": 0,
                "11": 0
              },
              "instagram": {
                "0": 0,
                "1": 0,
                "2": 0,
                "3": 0,
                "4": 0,
                "5": 0,
                "6": 0,
                "7": 0,
                "8": 0,
                "9": 0,
                "10": 0,
                "11": 0
              },
              "linkedin": {
                "0": 0,
                "1": 0,
                "2": 0,
                "3": 0,
                "4": 0,
                "5": 0,
                "6": 0,
                "7": 0,
                "8": 0,
                "9": 0,
                "10": 0,
                "11": 0
              },
              "tina": {
                "0": 0,
                "1": 0,
                "2": 0,
                "3": 0,
                "4": 0,
                "5": 0,
                "6": 0,
                "7": 0,
                "8": 0,
                "9": 0,
                "10": 0,
                "11": 0
              }
            },
            "total_app": 0,
            "populer_topic": {},
            "pending_appointment": 0,
            "location": "Asia/Calcutta",
            "done_appointment": 0,
            "client_id": "b0808768-9544-4e5d-820c-9f1f35402e9c",
            "total_leads": 0,
            "popular_topic": {
              "Glaucoma": "0",
              "Cataract": "0",
              "clinic": "0",
              "cataract": "0"
            },
            "total_feedback": 0,
            "appStatus": {
              "confirmed": 0,
              "cancelled": 0,
              "rescheduled": 0
            },
            "top_intent": {
              "Appointment_book_bot": "0",
              "Appointment_book_bot_demo": "0",
              "User_Form": "0",
              "TinaOphthalWelcome": "0",
              "Ophthal_Treatment": "0"
            },
            "total_appointments": 0
          }
        }


      },
      error: (e) => {
        this.chatBotAnalytics = {
          "user_data": {
            "0": 0,
            "1": 0,
            "2": 0,
            "3": 0,
            "4": 0,
            "5": 0,
            "6": 0,
            "7": 0,
            "8": 0,
            "9": 0,
            "10": 0,
            "11": 0
          },
          "common_disease": "",
          "avg_waiting_time": 0,
          "hot_leads": 0,
          "total_users": 0,
          "total_messages": 0,
          "old_appointment": 0,
          "active_hours": 0,
          "top_active_hours": {
            "13:00-14:00": 0,
            "15:00-16:00": 0,
            "11:00-12:00": 0,
            "09:00-10:00": 0,
            "05:00-06:00": 0
          },
          "unique_users": "0",
          "total_leads_last_month": {
            "whatsapp": 0,
            "youtube": 0,
            "total": 0,
            "twitter": 0,
            "messenger": 0,
            "facebook": 0,
            "instagram": 0,
            "linkedin": 0,
            "tina": 0
          },
          "new_appointment": 0,
          "user_feedbacks": {
            "negative": 0,
            "positive": 0
          },
          "user_ratings": {
            "5": 0,
            "4": 0,
            "3": 0,
            "2": 0,
            "1": 0,
          },
          "total_ratings": 0,
          "cold_leads": 0,
          "leads": {
            "whatsapp": {
              "0": 0,
              "1": 0,
              "2": 0,
              "3": 0,
              "4": 0,
              "5": 0,
              "6": 0,
              "7": 0,
              "8": 0,
              "9": 0,
              "10": 0,
              "11": 0
            },
            "youtube": {
              "0": 0,
              "1": 0,
              "2": 0,
              "3": 0,
              "4": 0,
              "5": 0,
              "6": 0,
              "7": 0,
              "8": 0,
              "9": 0,
              "10": 0,
              "11": 0
            },
            "twitter": {
              "0": 0,
              "1": 0,
              "2": 0,
              "3": 0,
              "4": 0,
              "5": 0,
              "6": 0,
              "7": 0,
              "8": 0,
              "9": 0,
              "10": 0,
              "11": 0
            },
            "messenger": {
              "0": 0,
              "1": 0,
              "2": 0,
              "3": 0,
              "4": 0,
              "5": 0,
              "6": 0,
              "7": 0,
              "8": 0,
              "9": 0,
              "10": 0,
              "11": 0
            },
            "facebook": {
              "0": 0,
              "1": 0,
              "2": 0,
              "3": 0,
              "4": 0,
              "5": 0,
              "6": 0,
              "7": 0,
              "8": 0,
              "9": 0,
              "10": 0,
              "11": 0
            },
            "instagram": {
              "0": 0,
              "1": 0,
              "2": 0,
              "3": 0,
              "4": 0,
              "5": 0,
              "6": 0,
              "7": 0,
              "8": 0,
              "9": 0,
              "10": 0,
              "11": 0
            },
            "linkedin": {
              "0": 0,
              "1": 0,
              "2": 0,
              "3": 0,
              "4": 0,
              "5": 0,
              "6": 0,
              "7": 0,
              "8": 0,
              "9": 0,
              "10": 0,
              "11": 0
            },
            "tina": {
              "0": 0,
              "1": 0,
              "2": 0,
              "3": 0,
              "4": 0,
              "5": 0,
              "6": 0,
              "7": 0,
              "8": 0,
              "9": 0,
              "10": 0,
              "11": 0
            }
          },
          "total_app": 0,
          "populer_topic": {},
          "pending_appointment": 0,
          "location": "Asia/Calcutta",
          "done_appointment": 0,
          "client_id": "b0808768-9544-4e5d-820c-9f1f35402e9c",
          "total_leads": 0,
          "popular_topic": {
            "Glaucoma": "0",
            "Cataract": "0",
            "clinic": "0",
            "cataract": "0"
          },
          "total_feedback": 0,
          "appStatus": {
            "confirmed": 0,
            "cancelled": 0,
            "rescheduled": 0
          },
          "top_intent": {
            "Appointment_book_bot": "0",
            "Appointment_book_bot_demo": "0",
            "User_Form": "0",
            "TinaOphthalWelcome": "0",
            "Ophthal_Treatment": "0"
          },
          "total_appointments": 0
        }
      },
      complete: () => { }
    })




  }

  onLeadFilterChange(filterKey: string) {
    this.leadActiveFilter = filterKey;
    this.showLeadCustomRange = filterKey === 'custom';
    if (filterKey !== 'custom') {
      this.leadLoading = false;
      this.fnGetLeadAnalytics();
    }
  }

  applyLeadCustomRange() {
    if (!this.leadCustomStart || !this.leadCustomEnd) return;
    this.leadLoading = false;
    this.fnGetLeadAnalytics();
  }

  fnGetLeadAnalytics() {
    const { start_date, end_date } = this.getDateRange(this.leadActiveFilter, this.leadCustomStart, this.leadCustomEnd);
    const param = {
      hospital_id: this.localStorage.getHospitalId(),
      start_date,
      end_date
    };
    this.api.getLeadAnalytics(param).subscribe({
      next: (res) => {
        if (res) {
          this.leadsAnalytics = res;
          this.leadLoading = true;
          this.totalLeads = res.total_leads;
        }
      },
      error: (e) => {
        this.leadLoading = true;
        this.leadsAnalytics = {
          "platform_wise_leads": {
            "tina":    { "Mar": 0, "Feb": 0, "Jan": 0, "Dec": 0, "Nov": 0, "Oct": 0, "Sep": 0, "Aug": 0, "Jul": 0, "Jun": 0, "May": 0, "Apr": 0 },
            "manual":  { "Mar": 0, "Feb": 0, "Jan": 0, "Dec": 0, "Nov": 0, "Oct": 0, "Sep": 0, "Aug": 0, "Jul": 0, "Jun": 0, "May": 0, "Apr": 0 },
            "whatsapp":{ "Mar": 0, "Feb": 0, "Jan": 0, "Dec": 0, "Nov": 0, "Oct": 0, "Sep": 0, "Aug": 0, "Jul": 0, "Jun": 0, "May": 0, "Apr": 0 }
          },
          "leads_types":  { "Hot Leads": "0", "Cold Leads": "0", "Warm Leads": "0", "New Leads": "0" },
          "leads_status": { "Completed": "0", "Follow Up": "0", "Communicated": "0", "Pending": "0" },
          "total_leads": "0", "completed_leads": "0", "pending_leads": "0",
          "communicated_leads": "0", "followup_leads": "0"
        };
      }
    });
  }
  onAppointmentFilterChange(filterKey: string) {
    this.appointmentActiveFilter = filterKey;
    this.showAppointmentCustomRange = filterKey === 'custom';
    if (filterKey !== 'custom') {
      this.appointmentLoading = false;
      this.fnGetAppointmentAnalytics();
    }
  }

  applyAppointmentCustomRange() {
    if (!this.appointmentCustomStart || !this.appointmentCustomEnd) return;
    this.appointmentLoading = false;
    this.fnGetAppointmentAnalytics();
  }

  fnGetAppointmentAnalytics() {
    const { start_date, end_date } = this.getDateRange(this.appointmentActiveFilter, this.appointmentCustomStart, this.appointmentCustomEnd);
    const param = {
      hospital_id: this.localStorage.getHospitalId(),
      start_date,
      end_date
    };
    this.api.getAppointmentAnalytics(param).subscribe({
      next: (res) => {
        if (res) {
          this.appointmentAnalytics = res;
          this.appointmentLoading = true;
        }
      },
      error: (e) => {
        this.appointmentLoading = true;
        this.appointmentAnalytics = {
          "platform_wise_appointments": {
            "tina":    { "Mar": 0, "Feb": 0, "Jan": 0, "Dec": 0, "Nov": 0, "Oct": 0, "Sep": 0, "Aug": 0, "Jul": 0, "Jun": 0, "May": 0, "Apr": 0 },
            "manual":  { "Mar": 0, "Feb": 0, "Jan": 0, "Dec": 0, "Nov": 0, "Oct": 0, "Sep": 0, "Aug": 0, "Jul": 0, "Jun": 0, "May": 0, "Apr": 0 },
            "whatsapp":{ "Mar": 0, "Feb": 0, "Jan": 0, "Dec": 0, "Nov": 0, "Oct": 0, "Sep": 0, "Aug": 0, "Jul": 0, "Jun": 0, "May": 0, "Apr": 0 }
          },
          "appointment_types":  { "New": "0", "Follow Up": "0" },
          "appointment_visits": { "Clinic": "0", "Online": "0", "Home Visit": "0" },
          "appointment_status": { "Completed": "0", "Check In": "0", "Check Out": "0", "Pending": 0, "Rescheduled": "0", "Cancelled": "0" },
          "total": "0", "completed": "0", "pending": 0, "check_in": "0", "cancelled": "0"
        };
      }
    });
  }
  @HostListener('window:resize', ['$event'])
    onResize(event: Event) {
      this.isMobileView = window.innerWidth <= 1024;
    }
  
  handleScrollLeft()  {
    const container = this.scrollContainer.nativeElement;
    container.scrollBy({ left: -150, behavior: 'smooth' });
  }
  
  handleScrollRight() {
    const container = this.scrollContainer.nativeElement;
    container.scrollBy({ left: 150, behavior: 'smooth' });
  }

}
